export default "__VITE_ASSET__BFwgMbhE__"